import * as React from "react"
import Menu from "@mui/material/Menu"
import Tooltip from "@mui/material/Tooltip"
import styled from "@emotion/styled"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormControl from "@mui/material/FormControl"
import Divider from "@mui/material/Divider"
import Button from "@mui/material/Button"
import { Stack } from "@mui/material"

export default function Filter({ filterState, setFilterState, callFunction }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleStatusChange = (event) => {
    setFilterState({ ...filterState, status: event.target.value })
  }

  const handleRoleChange = (event) => {
    setFilterState({ ...filterState, role: event.target.value })
  }

  const handleApply = () => {
    callFunction(1)
    setAnchorEl(null)
  }

  const handleClear = () => {
    setFilterState({})
    callFunction(1, true)
    setAnchorEl(null)
  }

  return (
    <>
      <Tooltip title="Filter">
        <FilterAltIcon
          className="pointer"
          style={{
            margin: "0 1rem 0 1rem",
          }}
          onClick={handleClick}
        />
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Container>
          <FormControl>
            <strong>By Status</strong>
            <RadioGroup
              row
              aria-labelledby="status-radio-buttons-group"
              name="status-radio-buttons-group"
              defaultValue={filterState?.status || ""}
              onChange={handleStatusChange}
            >
              <FormControlLabel value="Pending" control={<Radio />} label="Pending" />
              <FormControlLabel value="Resolved" control={<Radio />} label="Resolved" />
              <FormControlLabel value="Rejected" control={<Radio />} label="Rejected" />
            </RadioGroup>
          </FormControl>
          <Divider />
          <FormControl>
            <strong>Raised By</strong>
            <RadioGroup
              row
              aria-labelledby="role-radio-buttons-group"
              name="role-radio-buttons-group"
              defaultValue={filterState?.role || ""}
              onChange={handleRoleChange}
            >
              <FormControlLabel value="Seeker" control={<Radio />} label="Customer" />
              <FormControlLabel value="HouseKeeper" control={<Radio />} label="Housekeeper" />
              <FormControlLabel value="BabySitter" control={<Radio />} label="Babysitter" />
            </RadioGroup>
          </FormControl>
          {/* FROM AND TO DATE PICKER */}
          {/* <div className="date_div">
            <strong>By Date</strong>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField
                id="Date From"
                type={"date"}
                fullWidth
                defaultValue={filterState.fromDate ? moment(filterState.fromDate).format("YYYY-MM-DD") : ""}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    fromDate: moment(e.target.value).format("YYYY-MM-DD"),
                  })
                }}
              />

              <TextField
                id="Date To"
                type={"date"}
                fullWidth
                defaultValue={filterState.toDate ? moment(filterState.toDate).format("YYYY-MM-DD") : ""}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    toDate: moment(e.target.value).format("YYYY-MM-DD"),
                  })
                }}
              />
            </Stack>
          </div> */}
          <Divider />

          <Stack direction="row" justifyContent="flex-end">
            <Button onClick={handleClear}>Clear</Button>
            <Button onClick={handleApply}>Apply</Button>
          </Stack>
        </Container>
      </Menu>
    </>
  )
}

const Container = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
